/* Browse by Genus directory: sort toggle, live filter, letter bar.
   Both sort orders are already in the DOM. This script only shows one at a
   time, points the letter bar at the visible one, and hides rows that do not
   match the filter box. With scripting off the page keeps the common-name
   order, a working letter bar, and every row. */
(function () {
  function init(root) {
    if (root.dataset.js === 'on') return;
    root.dataset.js = 'on';

    var lists = {};
    root.querySelectorAll('[data-genus-list]').forEach(function (el) {
      lists[el.getAttribute('data-genus-list')] = el;
    });

    var alpha = root.querySelector('[data-genus-alpha]');
    var empty = root.querySelector('[data-genus-empty]');
    var input = root.querySelector('[data-genus-filter]');
    var buttons = root.querySelectorAll('[data-genus-sort]');
    var activeSort = root.getAttribute('data-active-sort') || 'common';

    function letterSet(sort) {
      if (!alpha) return '';
      return alpha.getAttribute('data-letters-' + sort) || '';
    }

    function paintAlphabet(sort) {
      if (!alpha) return;
      var present = letterSet(sort);
      alpha.querySelectorAll('[data-letter]').forEach(function (node) {
        var letter = node.getAttribute('data-letter');
        var live = present.indexOf(letter) !== -1;
        var replacement;
        if (live && node.tagName !== 'A') {
          replacement = document.createElement('a');
        } else if (!live && node.tagName === 'A') {
          replacement = document.createElement('span');
        }
        var target = node;
        if (replacement) {
          replacement.className = node.className;
          replacement.setAttribute('data-letter', letter);
          replacement.textContent = letter;
          node.parentNode.replaceChild(replacement, node);
          target = replacement;
        }
        if (live) {
          target.classList.remove('is-inert');
          target.removeAttribute('aria-hidden');
          target.setAttribute('href', '#genus-' + sort + '-' + letter);
        } else {
          target.classList.add('is-inert');
          target.setAttribute('aria-hidden', 'true');
          target.removeAttribute('href');
        }
      });
    }

    function setSort(sort) {
      if (!lists[sort]) return;
      activeSort = sort;
      root.setAttribute('data-active-sort', sort);
      Object.keys(lists).forEach(function (key) {
        lists[key].hidden = key !== sort;
      });
      buttons.forEach(function (btn) {
        var on = btn.getAttribute('data-genus-sort') === sort;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      paintAlphabet(sort);
      applyFilter();
    }

    function applyFilter() {
      var list = lists[activeSort];
      if (!list) return;
      var term = (input && input.value ? input.value : '').trim().toLowerCase();
      var matches = 0;

      list.querySelectorAll('[data-genus-group]').forEach(function (group) {
        var shown = 0;
        group.querySelectorAll('[data-genus-row]').forEach(function (row) {
          var hit = !term || (row.getAttribute('data-search') || '').indexOf(term) !== -1;
          row.hidden = !hit;
          if (hit) shown++;
        });
        group.hidden = shown === 0;
        matches += shown;
      });

      if (empty) empty.hidden = matches !== 0;
      list.hidden = matches === 0;
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setSort(btn.getAttribute('data-genus-sort'));
      });
    });

    if (input) {
      input.addEventListener('input', applyFilter);
      input.addEventListener('search', applyFilter);
    }

    setSort(activeSort);
  }

  function boot() {
    document.querySelectorAll('[data-genus-dir]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
